import { render, staticRenderFns } from "./AuctionCurrentLevel.vue?vue&type=template&id=a06b897a&"
import script from "./AuctionCurrentLevel.vue?vue&type=script&lang=js&"
export * from "./AuctionCurrentLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports